import newInboxRuleService from '../services/newInboxRuleService';
import NewInboxRuleResponse from 'owa-service/lib/contract/NewInboxRuleResponse';
import { action } from 'satcheljs/lib/legacy';
import datapoints from '../datapoints';
import InboxRuleActionSource from '../store/schema/InboxRuleActionSource';
import { ActionDatapoint, DatapointStatus, returnTopExecutingActionDatapoint } from 'owa-analytics';
import runRule from '../actions/actionCreators/runRuleNow';
import canRunRule from 'owa-inbox-rules-option/lib/utils/canRunRule';
import NewInboxRuleData from 'owa-service/lib/contract/NewInboxRuleData';
import InboxRule from 'owa-service/lib/contract/InboxRule';

let globalRequestCount = 0;
let requestId = ++globalRequestCount;

export default action('newInboxRuleAction', datapoints.createNewInboxRuleDatapoint)(
    async function newInboxRuleAction(
        inboxRule: NewInboxRuleData,
        actionSource: InboxRuleActionSource,
        onSuccess: (createdRule?: InboxRule) => void,
        onFailure: () => void,
        shouldRunRuleNow: boolean
    ): Promise<void> {
        let datapoint = returnTopExecutingActionDatapoint();

        return newInboxRuleService(inboxRule)
            .then(response => {
                // We check to make sure the response we are processing is from the most recent request. This prevents us from showing
                // the status of a previous request instead of the current one
                if (requestId != globalRequestCount) {
                    if (!response.WasSuccessful) {
                        logResponseFailure(datapoint, response);
                    }
                    return;
                }
                if (response.WasSuccessful) {
                    if (shouldRunRuleNow && canRunRule(response.InboxRule)) {
                        runRule(response.InboxRule);
                    }
                    onSuccess(response.InboxRule);
                } else {
                    logResponseFailure(datapoint, response);
                    onFailure();
                }
            })
            .catch(error => {
                logResponseFailure(datapoint);
                onFailure();
            });
    }
);

function logResponseFailure(datapoint: ActionDatapoint, response?: NewInboxRuleResponse) {
    let errorMessage = response
        ? 'There was an error when creating a new rule'
        : 'Response WasSuccessful was false';
    datapoint.endWithError(DatapointStatus.ServerError, new Error(errorMessage));
}
